import { Controller } from "@hotwired/stimulus";

/**
 * Reveal Controller
 *
 * Adds scroll-triggered reveal animations to elements.
 * Apply data-controller="reveal" to a container to automatically
 * reveal child elements with .reveal or .reveal-scale classes.
 */
export default class extends Controller<HTMLElement> {
  private observer: IntersectionObserver | null = null;

  connect(): void {
    this.setupObserver();
  }

  disconnect(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private setupObserver(): void {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            // Unobserve after revealing (one-time animation)
            this.observer?.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    // Observe all reveal elements within this controller's scope
    const revealElements = this.element.querySelectorAll(".reveal, .reveal-scale");
    revealElements.forEach((el) => {
      this.observer?.observe(el);
    });
  }
}
